import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Form from 'react-jsonschema-form';
import InfiniteCalendar from 'react-infinite-calendar';
import { Button } from '@material-ui/core';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

class DialogMui extends Component{
    
    render(){
        const { block, open,  title, text, children, submit, close, classes, disabledSubmit, submitTitle } = this.props;

        let isOpen = open
        if (typeof block === "boolean"){
            isOpen = block
        } else if (typeof block === "string"){
            isOpen = block === "block" ? true : false
        }

        // console.log('================= DialogMui ===================');
        // console.log(this.props);
        // console.log(isOpen);
        // console.log(block);
        // console.log('====================================');
        return (
            <Dialog
                disableEnforceFocus
                disableBackdropClick
                open={isOpen}
                onClose={close}
                aria-labelledby="form-dialog-title"
                maxWidth={this.props.maxWidth || "sm"}
                // fullScreen={fullScreen}
                fullWidth
                scroll="body"
            >
                <DialogTitle disableTypography className={classes.root}>
                    <Typography variant="h6">{title}</Typography>
                    {close ? (
                        <IconButton aria-label="Close" className={classes.closeButton} onClick={close}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </DialogTitle>
                    <div className="dialog-banner-footer"></div>
                <DialogContent>
                    {text || children}
                </DialogContent>
                {submit &&
                    <DialogActions>
                        <Button 
                            onClick={close} 
                        >
                            Annuler
                        </Button>
                        {submit}
                    </DialogActions>
                }
                { this.props.submitAction &&
                
                    <DialogActions>
                    
                        <Button variant="contained" onClick={this.props.submitAction} color="secondary" disabled={disabledSubmit}>
                            {submitTitle || "Valider"}
                        </Button>
                        <Button onClick={close} color="default">
                            Annuler
                        </Button>
                    </DialogActions>
                }
            </Dialog>
        )
    }
}

export default withMobileDialog()(withStyles(styles)(DialogMui)) ;

const DialogMuiLocal =  withMobileDialog()(withStyles(styles)(DialogMui));

export class FormDialogElem extends React.Component {
    state = {
        form:{
            uiSchema:{},
            jsonSchema:{},
        },
    }
    componentDidMount = async () => {
        console.log("CDM FormDialog");
        try {
            const infos = await fetch('/schema/get?idSchema='+this.props.ID,{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            let body = await infos.json();

            if(body.error){
                console.log("[ERROR] error get Schemas", body);  
                return false
            } else {
                console.log('====================================');
                console.log({body});
                console.log('====================================');
                this.setState({
                    form:{
                        uiSchema:JSON.parse(body.uiSchema),
                        jsonSchema:JSON.parse(body.jsonSchema),
                    },
                    schemaID:body.schemaID,
                })
                return true
            }
        } catch (e) {
            console.log(e);
            return false
        }  
    }
    render(){
        console.log('====================================');
        console.log("[STATE]FormDialogElem render", this.state);
        console.log('====================================');
        return (
            <DialogMuiLocal
                title="Pévisualisation du Formulaire"
                block={true}
                close={this.props.close}
                height="500px"
            >
                {this.state.form.uiSchema && 
                    <Form
                        schema={this.state.form.jsonSchema}
                        uiSchema={this.state.form.uiSchema}
                        >
                        <Button variant="contained" color="secondary" disabled>
                            Valider
                        </Button>
                    </Form>
                }
            </DialogMuiLocal>
        )
    }
}
const FormDialog =  withMobileDialog()(withStyles(styles)(FormDialogElem));


class Calendar extends React.Component {
    state = { }

    render(){
        console.log('====================================');
        console.log("[PROPS] CalendarDialog render", this.props);
        console.log('====================================');
        const { selected, title, close, noMin, classes} = this.props;

        return (
            <Dialog
                disableBackdropClick
                open={true}
                onClose={close}
                aria-labelledby="form-dialog-title"
                maxWidth="sm"
                fullWidth
                scroll="body"
            >
                <DialogTitle disableTypography className={classes.root}>
                    <Typography variant="h6">{title}</Typography>
                    {close ? (
                        <IconButton aria-label="Close" className={classes.closeButton} onClick={close}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </DialogTitle>
                    <p className="dialog-banner-footer"></p>
                <DialogContent>
                    <InfiniteCalendar
                        locale={{
                            locale: require('date-fns/locale/fr'),
                            headerFormat: 'dddd, D MMM',
                            weekdays: ["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],
                            blank: 'Aucune date selectionnée',
                            todayLabel: {
                                long: 'Aujourd\'hui',
                                short: 'Auj.'
                            },
                            weekStartsOn:1
                        }}
                        onSelect={this.props.handleChangeDate}
                        selected={selected}
                        minDate={noMin ? new Date(0) : Today}
                        width={'100%'}
                        height={400}
                        theme={{
                            accentColor: 'rgb(18, 100, 7)',
                            floatingNav: {
                                background: 'rgb(255, 221, 68)',
                                chevron: '#FFA726',
                                color: '#FFF',
                            },
                            headerColor: 'rgb(18, 100, 7)',
                            selectionColor: 'orange',
                            textColor: {
                                active: '#FFF',
                                default: '#333',
                            },
                            todayColor: '#FFA726',
                            weekdayColor: 'forestgreen', 
                        }}
                    />
                </DialogContent>
                
            </Dialog>
        )
    }
}
const CalendarDialog =  withMobileDialog()(withStyles(styles)(Calendar));

export {
    CalendarDialog,
    FormDialog
};

const Today = new Date()